import { Col, Row, Space, Radio } from "antd";
import { Input, Select } from "components/form";
import { useTranslation } from "react-i18next";
import { Field, Form, Formik } from "formik";
import { REGISTER_TYPE } from "features/authentication/schemas/signUpSchema";
import { useState } from "react";
import useScrollTo from "rc-virtual-list/lib/hooks/useScrollTo";



const CompanyInfo = ({
  header = null,
  companyTypeOptions = [],
  lower = null,
  getTaxConpanyOption = () => { },
  setFieldValue = () => { },
  values = {},
  optionSearchTax = [],
}) => {
  const { t } = useTranslation();
  const [typeCode, setTypeCode] = useState();

  console.log("values.companyTypeId", typeCode);
  return (
    <Space direction="vertical" size={16} style={{ width: "100%" }}>
      {header}
      <Row span={12} style={{ marginTop: "15px" }} >
        <Radio.Group
          onChange={(e) => {
            console.log("ssssssss", e.target.value);
            setFieldValue("registerType", e.target.value);
          }}
          value={values.registerType}
        >
          <Radio value={REGISTER_TYPE.DOMESTIC}>
            {t("signup.input.thai")}
          </Radio>
          <Radio value={REGISTER_TYPE.OTHER}>
            {t("signup.input.other")}
          </Radio>
        </Radio.Group>
      </Row>

      <Row>
        {values.registerType === REGISTER_TYPE.DOMESTIC ? (
          <>
            <Col span={12} style={{ paddingRight: "12px" }}>
              <Select
                // labelInValue={true}
                name="taxId"
                label={t("signup.input.companyName")}
                options={optionSearchTax}
                notFoundContent={true}
                filterOption={false}
                // open={values.taxId === undefined}
                onSearch={(val) => {
                  // console.log("searchtext", val, val.length);
                  if (val && val.length >= 3) {
                    getTaxConpanyOption({ "searchtext": val })
                    setFieldValue("taxId", undefined)
                  }
                }}
                onChange={(val, _) => {
                  console.log("onChange val", val, _?.fullNameTh, values.taxId);
                  setFieldValue("companyName", _?.fullNameTh)
                  setFieldValue("companyNameEn", _?.fullNameTh)
                }}
                placeholder={t('please-select-1')}
                size="large"
              />
            </Col>
            <Col span={12} style={{ paddingLeft: "12px" }}>
              <Input
                disabled
                name="taxId"
                label={t("signup.input.taxId")}
                placeholder={t("signup.input.taxId")}
                size="large"
              />
            </Col>
          </>
        ) : (
          <>
            <Col span={12} style={{ paddingRight: "12px" }}>
              <Input
                name="companyName"
                label={t("signup.input.companyName")}
                placeholder={`${t("signup.input.companyName")}`}
                size="large"
                onChange={(val) => {
                  setFieldValue("companyName", val)
                  setFieldValue("companyNameEn", val)
                }}
                required
              />
            </Col>
            <Col span={12} style={{ paddingLeft: "12px" }}>
              <Input
                name="taxId"
                label={t("signup.input.taxId")}
                placeholder={t("signup.input.taxId")}
                size="large"
                required
              />
            </Col>
          </>
        )}
      </Row>
      <Row>
        <Col span={12} style={{ paddingRight: "12px" }}>
          <Select
            // labelInValue={true}
            name="companyTypeId"
            label={t('employee.business-type')}
            options={companyTypeOptions}
            notFoundContent={true}
            filterOption={false}
            // open={values.taxId === undefined}
            onSearch={(val) => {
              // console.log("searchtext", val, val.length);
              if (val && val.length >= 3) {
                getTaxConpanyOption({ "searchtext": val })
                // setFieldValue("taxId", undefined)
              }
            }}
            onChange={(val, item) => {
              // console.log("onChange val", item);
              setTypeCode(item?.code)
            }}
            placeholder={t('please-select-1')}
            size="large"
            required
          />
        </Col>
        <Col span={12} style={{ paddingLeft: "12px" }}>
          <Input
            required
            name="numberOfEmployees"
            label={t("company_profile.label.number_of_employees")}
            placeholder={t('number-of-employees')}
            size="large"
          />
        </Col>
      </Row>
      {typeCode === "COMPANY_TYPE_21" && (
        <Row>
          <Col span={12} style={{ paddingRight: "12px" }}>
            <Input
              name="companyTypeDesc"
              required
              label={t("company_profile.label.companyType_description")}
              placeholder={t("description.please_enter_description")}
              rows="4"
              type="textarea"
            />
          </Col>
        </Row>)}
      {lower}
    </Space >

  );
};

export default CompanyInfo;
